export default __webpack_public_path__ + "static/media/mobileBgOr.58a0d4dd.webp";